import { Routes, Route } from "react-router-dom";
import SignalAILandingPage from "./landingPage";
import GuidePage from "./landingPage/page2";
import ScanPage from "./Scan";
import SignalAIResult from "./Result";
import Summary from "./Result/summary";

const SignalAI = (params) => {
    return (
        <div className="h-full w-full">
            <Routes>
                <Route path="/" element={<SignalAILandingPage params={params} />} />
                <Route path="/guide" element={<GuidePage />} />
                <Route path="/capture" element={<ScanPage />} />
                <Route path="/result" element={<SignalAIResult />} />
                <Route path="/summary" element={<Summary />} />
            </Routes>
        </div>
    )
}

export default SignalAI